import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter as Router } from 'react-router-dom'
import './utils/vconsole'

function AppLoadingFallback() {
  return (
    <main className="appLoadingFallback" role="status" aria-label="Loading">
      <span className="appLoadingFallbackSpinner" aria-hidden="true" />
    </main>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <Router>
    <Suspense fallback={<AppLoadingFallback />}>
      <App />
    </Suspense>
  </Router>,

  // </React.StrictMode>,
)
reportWebVitals()
